import { AccountTypes } from "@Interfaces/Entities/User";

const normalizeAccountType = (accountType?: string | null) =>
    `${accountType || ""}`.toLowerCase().replace(/[_\s-]/g, "");

export type EntitlementKey =
    | "can_collect_events"
    | "can_access_reports"
    | "can_export_data"
    | "can_customize_branding"
    | "can_use_advanced_data_collection"
    | "can_view_ai_teaser"
    | "can_use_ai_analyst";

export type AccountEntitlements = Record<EntitlementKey, boolean>;

export const ACCOUNT_ENTITLEMENTS: Record<AccountTypes, AccountEntitlements> = {
    [AccountTypes.Freemium]: {
        can_collect_events: true,
        can_access_reports: false,
        can_export_data: false,
        can_customize_branding: false,
        can_use_advanced_data_collection: false,
        can_view_ai_teaser: false,
        can_use_ai_analyst: false,
    },
    [AccountTypes.Premium]: {
        can_collect_events: true,
        can_access_reports: true,
        can_export_data: true,
        can_customize_branding: true,
        can_use_advanced_data_collection: true,
        can_view_ai_teaser: true,
        can_use_ai_analyst: false,
    },
    [AccountTypes.PremiumAI]: {
        can_collect_events: true,
        can_access_reports: true,
        can_export_data: true,
        can_customize_branding: true,
        can_use_advanced_data_collection: true,
        can_view_ai_teaser: true,
        can_use_ai_analyst: true,
    },
};

export const getAccountEntitlements = (
    accountType?: string | null
): AccountEntitlements => {
    const normalized = normalizeAccountType(accountType) as AccountTypes;

    return (
        ACCOUNT_ENTITLEMENTS[normalized] ??
        ACCOUNT_ENTITLEMENTS[AccountTypes.Freemium]
    );
};

export const hasEntitlement = (
    accountType: string | null | undefined,
    entitlement: EntitlementKey
): boolean => getAccountEntitlements(accountType)[entitlement];

export const hasPremiumFeatures = (accountType?: string | null): boolean => {
    return hasEntitlement(accountType, "can_access_reports");
};

export const hasAiAssistantAccess = (accountType?: string | null): boolean =>
    hasEntitlement(accountType, "can_use_ai_analyst");
